import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  TitleContainer,
  TitleText,
  CardsContainer,
  PromptCard,
  CardTitleContainer,
  CardTitle,
  CardDescriptionContainer,
  CardDescription,
} from "./styled";

interface DispatchPromptsProps {
  onPromptClick: (prompt: string) => void;
}

export default function DispatchPrompts({ onPromptClick }: DispatchPromptsProps) {
  const { t: translate } = useTranslation();
  const [selectedCard, setSelectedCard] = useState<string | null>(null);

  const promptCards = [
    {
      id: "today-orders",
      titleKey: "dumontDispatchShowTodayOrders",
      descriptionKey: "dumontDispatchShowTodayOrdersDesc",
    },
    {
      id: "find-customer",
      titleKey: "dumontDispatchFindCustomer",
      descriptionKey: "dumontDispatchFindCustomerDesc",
    },
    {
      id: "track-status",
      titleKey: "dumontDispatchTrackStatus",
      descriptionKey: "dumontDispatchTrackStatusDesc",
    },
    {
      id: "optimize-routes",
      titleKey: "dumontDispatchOptimizeRoutes",
      descriptionKey: "dumontDispatchOptimizeRoutesDesc",
    },
  ];

  const handleCardClick = (card: typeof promptCards[0]) => {
    setSelectedCard(card.id);
    onPromptClick(translate(card.titleKey));
  };

  return (
    <Container>
      <TitleContainer>
        <TitleText>{translate("dumontDispatchQuickActions")}</TitleText>
      </TitleContainer>

      <CardsContainer>
        {promptCards.map((card) => {
          const isSelected = selectedCard === card.id;
          return (
            <PromptCard key={card.id} onClick={() => handleCardClick(card)} isSelected={isSelected}>
              <CardTitleContainer>
                <CardTitle>{translate(card.titleKey)}</CardTitle>
              </CardTitleContainer>

              <CardDescriptionContainer>
                <CardDescription>{translate(card.descriptionKey)}</CardDescription>
              </CardDescriptionContainer>
            </PromptCard>
          );
        })}
      </CardsContainer>
    </Container>
  );
}
